import { createReducer } from 'src/helpers/reducer';
import { IBankAccountsState, ILoadDataSuccessPayload } from './types';
import actionsTypes from './actionTypes';

const initState: IBankAccountsState = {
  bankAccounts: undefined,
  isLoading: false,
  total: 0,
};

function onLoadBankAccountsRequest(state: IBankAccountsState): IBankAccountsState {
  return {
    ...state,
    isLoading: true,
  };
}

function onLoadBankAccountsSuccess(
  state: IBankAccountsState,
  { payload }: { payload: ILoadDataSuccessPayload },
): IBankAccountsState {
  const { bankAccounts, total, filteredTotal } = payload;

  return {
    ...state,
    bankAccounts,
    total,
    filteredTotal,
    isLoading: false,
  };
}

function onLoadBankAccountsError(state: IBankAccountsState) {
  return {
    ...state,
    isLoading: false,
  };
}

export default createReducer(initState, {
  [actionsTypes.LOAD_BANK_ACCOUNTS_REQUEST]: onLoadBankAccountsRequest,
  [actionsTypes.LOAD_BANK_ACCOUNTS_SUCCESS]: onLoadBankAccountsSuccess,
  [actionsTypes.LOAD_BANK_ACCOUNTS_ERROR]: onLoadBankAccountsError,
});
